import { classNames } from 'primereact/utils';
import { useAnnotationLabelsContext } from '../hooks';
import { Button, Checkbox, FilterIcon } from '@repo/atomic-components';
import { makeSelectBundlePageIdByPageIndex, selectViewportPageIndexInStore, useAppSelector } from '@/store';

export const FilterAnnotationLabelsControlPanel = () => {
  const { showFilteredLabels, filterAnnotationLabels, resetAnnotationLabels, addOrUpdateAnnotationLabel } =
    useAnnotationLabelsContext();
  const viewportPageIndexInStore = useAppSelector(selectViewportPageIndexInStore);

  const getBundlePageIdByPageIndex = useAppSelector(makeSelectBundlePageIdByPageIndex);

  if (!showFilteredLabels) {
    return null;
  }

  const pageId = getBundlePageIdByPageIndex(viewportPageIndexInStore);
  const labelsForCurrentPage = filterAnnotationLabels[pageId] || {};

  if (Object.keys(labelsForCurrentPage).length === 0 && labelsForCurrentPage.constructor === Object) {
    return null;
  }

  const handleSelectAll = () => {
    resetAnnotationLabels(pageId, true);
  };

  const handleDeselectAll = () => {
    resetAnnotationLabels(pageId, false);
  };

  return (
    <div
      className={classNames(
        'absolute top-1/8 right-4 z-10 -translate-y-1/2 transform',
        'max-h-[400px] min-w-[200px] overflow-y-scroll',
        'flex flex-col items-start justify-between',
        'bg-fletchers-white rounded-[4px] shadow-[0px_0px_4px_0px_#00000026]',
      )}
    >
      <div className="flex flex-col p-2">
        {Object.entries(labelsForCurrentPage).map(([label, value]) => (
          <label
            key={label}
            className="max-w-[300px] space-x-2 overflow-hidden text-[13px]/[19px] font-semibold overflow-ellipsis whitespace-nowrap"
          >
            <Checkbox
              type="checkbox"
              icon={<FilterIcon />}
              checked={value}
              onChange={() => {
                addOrUpdateAnnotationLabel(pageId, label, !value);
              }}
              className="text-[#D0D0CE] [&>[data-pc-section='box']]:peer-focus-visible:fixed"
            />
            <span title={label}>{label}</span>
          </label>
        ))}
      </div>
      <div className="flex space-x-2 self-center pb-2">
        <Button onClick={handleSelectAll} size="small">
          Select All
        </Button>
        <Button onClick={handleDeselectAll} size="small">
          Deselect All
        </Button>
      </div>
    </div>
  );
};
